import React from 'react'
import styles from './commentItemContent.module.css'
import { Divider, Input, Typography } from 'antd'
import { RightIcon } from '../../../../../../../../../Icons/rightIcon'
import { CommentItemType, PendingFile } from '../../../../../../../../createEscalation.models'
import { IEscalationFiles } from '../../../../../../../../../../Models/applicationModels'
import { PendingFileRow } from '../../../../../../../pendingFileRow/pendingFileRow.index'
import { isTypeDraftComment, isCommentEditable } from '../../commentItem.utils'
import { READ_COLLAPSED_ROWS, WRITE_MIN_ROWS, WRITE_MAX_ROWS } from './commentItemContent.constants'

const { TextArea } = Input

interface CommentItemContentProps {
    type: CommentItemType
    content: string | null
    onContentChange?: (value: string) => void
    files: IEscalationFiles[] | null
    pendingFiles: PendingFile[]
    onRemovePendingFile: (id: string) => void
}

export const CommentItemContent = ({
    type,
    content,
    onContentChange,
    files,
    pendingFiles,
    onRemovePendingFile,
}: CommentItemContentProps) => {

    const canEdit = isCommentEditable(type, onContentChange)
    const canWriteComment = isTypeDraftComment(type)

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!canEdit) return
        onContentChange?.(e.target.value)
    }

    const hasFiles = Array.isArray(files) && files.length > 0
    const hasPendingFiles = pendingFiles.length > 0
    const hasContent = !!content

    return (
        <div className={styles.commentItemContentContainer}>

            {(hasContent || canWriteComment) && (
                canWriteComment ? (
                    <TextArea
                        value={content ?? ''}
                        onChange={handleChange}
                        autoSize={{ minRows: WRITE_MIN_ROWS, maxRows: WRITE_MAX_ROWS }}
                        placeholder="Type your comment here..."
                        variant="borderless"
                        autoFocus
                        classNames={{
                            textarea: `${styles.commentItemContentInput} ${styles.commentItemContentInputWrite}`,
                        }}
                    />
                ) : (
                    <Typography.Paragraph
                        className={styles.readContent}
                        style={{ marginBottom: 0 }}
                        classNames={{action: styles.actionStyles}}
                        ellipsis={{
                            rows: READ_COLLAPSED_ROWS,
                            expandable: 'collapsible',
                            symbol: (expanded) => (expanded ? 'Show less' : 'Show more'),
                        }}
                    >
                        {content}
                    </Typography.Paragraph>
                )
            )}

            {hasFiles && (
                <>
                    {hasContent && (
                        <Divider className={styles.commentItemContentDivider} />
                    )}
                    <div className={styles.filesContainer}>
                        {files!.map((file) => (
                            <div className={styles.files} key={file.fileName}>
                                <RightIcon width={15} height={15} fillColor="#00A634" />
                                <a
                                    href={file.fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.fileName}
                                >
                                    {file.fileName}
                                </a>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {hasPendingFiles && (
                <>
                    <Divider className={styles.commentItemContentDivider} />
                    <div className={styles.pendingFilesContainer}>
                        {pendingFiles.map((file) => (
                            <PendingFileRow
                                key={file.id}
                                file={file}
                                onRemove={onRemovePendingFile}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}
